import { breakpointsTailwind, useBreakpoints, useMediaQuery } from '@vueuse/core'
export const useMobile = () => {
	const breakpoints = useBreakpoints(breakpointsTailwind)
	const isMobile = breakpoints.smaller('lg')
	const isDesktop = useMediaQuery('(min-width: 768px)')
	const deviceType = ref<'tablet' | 'desktop' | 'mobile' | null>(null)
	const ua = (import.meta.client && navigator.userAgent) || ''
	if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua as string)) {
		deviceType.value = 'tablet'
	} else if (
		/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
			ua as string
		)
	) {
		deviceType.value = 'mobile'
	} else {
		deviceType.value = 'desktop'
	}
	return { isMobile, deviceType, isDesktop }
}
